import React, { Component } from 'react';
import {valueCheck, percentageCheck, difference} from '../../helpers'
import HorizontalBar from './HorizontalBar';

export default class HorizontalBars extends Component {
  constructor(props) {
    super(props);

    this.state = { ...this.props.state };
  }
  render() {
    const {reportType, containerClass, pClass, selfAnswerScore, previousRevieweeAverages, reviewersAnswerScore, previousReviewerAverages, userColour, reviewerColour, variations, orderType} = this.props
    let scoreDifferences;
    if (reportType !== 'Self') {
      scoreDifferences = difference(selfAnswerScore, reviewersAnswerScore);
    }
    return (
      <div className={containerClass}>
        {reportType !== 'Self' && (
          <HorizontalBar 
            pClass={pClass}
            value={reviewersAnswerScore}
            barColour={reviewerColour}
            variations={variations}
          />
        )}

        {previousReviewerAverages && (
          <HorizontalBar 
            pClass={pClass}
            value={previousReviewerAverages}
            barColour={reviewerColour}
            variations={variations}
            comparison={true}
          />
        )}

        {reportType !== 'Team' && (
          <HorizontalBar 
            pClass={pClass}
            value={selfAnswerScore}
            barColour={userColour}
            variations={variations}
            difference={scoreDifferences}
            orderType={orderType}
          />
        )}

        {previousRevieweeAverages && (
          <HorizontalBar 
            pClass={pClass}
            value={previousRevieweeAverages}
            barColour={userColour}
            variations={variations}
            difference={scoreDifferences}
            orderType={orderType}
            comparison={true}
          />
        )}
      </div>
    );
  }
}
